import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { territoryUploadSaga } from './territorySaga';

export function* territorySaga() {
  yield takeLatest(sagaActions.UPLOAD_TERRITORY, territoryUploadSaga);
}
